/**
 * A basic circle SVG path.
 * @type {String}
 */
export const PATH = 'm35,2.5c17.955803,0 32.5,14.544199 32.5,32.5c0,17.955803 -14.544197,32.5 -32.5,32.5c-17.955803,0 -32.5,-14.544197 -32.5,-32.5c0,-17.955801 14.544197,-32.5 32.5,-32.5z';

/**
 * The circle path's full single dash, used to create partial circles.
 * @type {Number}
 */
export const CIRCLE_MAX = 204;

/**
 * Basic styles for circle paths.
 * @type {Object}
 */
export const BASE_CIRCLE_STYLE = {
    strokeDasharray: CIRCLE_MAX
};
